export default "__VITE_PUBLIC_ASSET__5f10bdb8__"